import { CityGroup } from '@/entities/campaign';
import { State, City } from 'country-state-city';
import { NCR_STATES, DELHI_NCR } from '@/shared/constants/cityGroups';

export const generateCityGroups = (): CityGroup[] => {
  const states = State.getStatesOfCountry('IN');
  const groups: CityGroup[] = [DELHI_NCR];

  for (const state of states) {
    if (NCR_STATES.includes(state.name)) continue;

    const cities = City.getCitiesOfState('IN', state.isoCode).map(c => c.name);
    const id = state.name.toLowerCase().replace(/\s+/g, '-');

    groups.push({
      id,
      name: state.name,
      displayName: state.name,
      image: 'https://images.justbaat.com/city-group/uttar-pradesh.png',
      disabled: true,
      states: [state.name],
      cities,
    });
  }

  return groups;
};

export const CITY_GROUPS: CityGroup[] = generateCityGroups();

export const getCityGroupById = (id: string): CityGroup | undefined => {
  return CITY_GROUPS.find(group => group.id === id);
};

export const getCityGroupFilters = (cityGroupId: string) => {
  const cityGroup = getCityGroupById(cityGroupId);
  if (!cityGroup) return null;

  return [
    {
      key: 'address.state',
      type: 'terms',
      value: cityGroup.states,
    },
    {
      key: 'address.city',
      type: 'terms',
      value: cityGroup.cities,
    },
  ];
};
